const doc = [({"da":({"js":({"admin":({"routes":({"webshop":({"tenant_photo_products":({"shop":"Shop"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;